import { PLUGIN_AUDIT, PLUGIN_MONITOR } from "metabase/plugins";
import MetabaseSettings from "metabase/utils/settings";

import { UsageAnalyticsNav } from "./components/UsageAnalyticsNav";
import { UsageHistoryLink } from "./components/UsageHistoryLink";
import { getUsageAnalyticsRoutes } from "./routes";

/**
 * Usage analytics: the activity log, the query log, the usage history of an
 * item and the report of what a person did, under Monitor, for admins and
 * the groups with the Usage analytics application permission. Does nothing
 * unless the instance has the `audit-app` feature, which turns on the logs.
 */
export function initializeUsageAnalyticsPlugin() {
  if (!MetabaseSettings.get("token-features")?.audit_app) {
    return;
  }

  Object.assign(PLUGIN_MONITOR, {
    isUsageAnalyticsEnabled: true,
    getUsageAnalyticsRoutes,
    UsageAnalyticsNav,
  } satisfies Partial<typeof PLUGIN_MONITOR>);

  PLUGIN_AUDIT.InsightsLink = UsageHistoryLink;
}
